import { render, staticRenderFns } from "./NewAddress.vue?vue&type=template&id=342d04fe&scoped=true&"
import script from "./NewAddress.vue?vue&type=script&lang=js&"
export * from "./NewAddress.vue?vue&type=script&lang=js&"
import style0 from "./NewAddress.vue?vue&type=style&index=0&id=342d04fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342d04fe",
  null
  
)

export default component.exports